import { render, staticRenderFns } from "./RowsSelector.vue?vue&type=template&id=61c2a71f"
import script from "./RowsSelector.vue?vue&type=script&lang=js"
export * from "./RowsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports